import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * TypingIndicator Component
 * Shows when someone is typing
 */
const TypingIndicator = ({ userName = 'Someone' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 2
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {userName} is typing
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 0.5
        }}
      >
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              backgroundColor: 'action.active',
              animation: 'typing 1.4s infinite',
              animationDelay: `${index * 0.2}s`,
              '@keyframes typing': {
                '0%, 60%, 100%': {
                  transform: 'translateY(0)',
                  opacity: 0.5
                },
                '30%': {
                  transform: 'translateY(-8px)',
                  opacity: 1
                }
              }
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TypingIndicator;
